import React from 'react';
import { IAuditoriaReceitasDiferidasResultado } from '../interfaces/IAuditoriaReceitasDiferidas';
import { TributoAuditoria } from '../interfaces/IAuditoria';
import { formatCurrency } from '../utils/formatters';

interface Props {
  resultado?: IAuditoriaReceitasDiferidasResultado;
  onSelecionar: (tributo: TributoAuditoria) => void;
}


// Governança de Receitas Diferidas — não é um tributo, é uma auditoria complementar que verifica
// se contas de Receita Diferida (Adiantamento de Clientes, Passivo Circulante) foram baixadas (NF
// emitida) dentro de 30 dias. Regra de 31/60 dias: 31-59 dias = Aviso de Compliance (emissão de
// NF, sem tributo); >= 60 dias = Erro de Conformidade (Custo de Omissão, matriz tributária completa).
const AuditoriaResumoReceitasDiferidas: React.FC<Props> = ({ resultado, onSelecionar }) => {
  if (!resultado) {
    return null;
  }

  const totalOcorrencias = resultado.receitasDiferidasPendentes?.length || 0;

  return (
    <div className='auditoria-card mt-5'>
      <h3>Resumo de Receitas Diferidas (Segregação Tributária)</h3>
      <p className='text-muted'>
        Auditoria complementar — receitas diferidas (adiantamentos de clientes, Passivo Circulante) sem baixa entre 31
        e 59 dias geram Aviso de Compliance (emissão de NF obrigatória, sem tributo); a partir de 60 dias, Custo de
        Omissão com tributação integral (PIS, COFINS, IRPJ, CSLL, ISS quando aplicável e Multa ECD). Clique para ver a
        análise detalhada.
      </p>

      <div className='table-responsive mt-4'>
        <table className='auditoria-table auditoria-table-tributos'>
          <thead>
            <tr>
              <th>Auditoria</th>
              <th className='text-end'>Impacto Fiscal Estimado</th>
              <th className='text-center'>Erros</th>
              <th className='text-center'>Avisos</th>
              <th className='text-center'>Alertas</th>
            </tr>
          </thead>

          <tbody>
            <tr className='auditoria-row-tributo' onClick={() => onSelecionar('AUDITORIA_RECEITAS_DIFERIDAS')}>
              <td className='auditoria-col-tributo'>
                <div className='d-flex align-items-center gap-2'>
                  <strong>Auditoria de Receitas Diferidas (Segregação Tributária)</strong>
                  <span className={`auditoria-status status-${resultado.status}`}>
                    {resultado.status}
                  </span>
                </div>
                <div className='auditoria-legislacao-inline'>
                  <div>{totalOcorrencias} receita{totalOcorrencias === 1 ? '' : 's'} diferida{totalOcorrencias === 1 ? '' : 's'} pendente{totalOcorrencias === 1 ? '' : 's'} (aviso ou erro) no período</div>
                  <div className='text-muted'>{resultado.mensagemDirecionamento}</div>
                </div>
              </td>
              <td className='text-end auditoria-col-highlight'>
                {formatCurrency(resultado.impactoFiscalTotal)}
                <div className='auditoria-kpi-help'>Custo de Omissão (≥ 60 dias): PIS + COFINS + IRPJ + CSLL + ISS (se aplicável) + Multa ECD Potencial (5% limitada a 1% da receita bruta)</div>
              </td>
              <td className='text-center'>
                <span className='auditoria-contador auditoria-contador-erro'>{resultado.totalErros}</span>
              </td>
              <td className='text-center'>
                <span className='auditoria-contador auditoria-contador-aviso'>{resultado.totalAvisos}</span>
              </td>
              <td className='text-center'>
                <span className='auditoria-contador auditoria-contador-alerta'>{resultado.totalAlertas}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AuditoriaResumoReceitasDiferidas;
